/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { IConfigurationModel } from "@nf/common";

import AppFooterMobile from "./AppFooterMobile";
import AppFooterDesktop from "./AppFooterDesktop";

import styles from "./AppFooter.module.scss";

export type AppFooterProps = {
  configuration?: IConfigurationModel;
};

export const AppFooter = ({ configuration }: AppFooterProps) => {
  return (
    <footer className={styles.footer}>
      <div className={styles.mobile}>
        <AppFooterMobile configuration={configuration} />
      </div>

      <div className={styles.desktop}>
        <AppFooterDesktop configuration={configuration} />
      </div>
    </footer>
  );
};

export default AppFooter;
